import '../../common/reset-styles.scss';
import '../../common';
import { initializeApplication } from 'Application/EntryPoint/initialization';
import { getLazyReactComponent } from 'Application/EntryPoint/lazyReactComponents';
import XMattersApp from './XMattersApp';

initializeApplication({ appComponent: XMattersApp, getLazyReactComponent });
